import { Canvas } from '@react-three/fiber';
import { Suspense } from 'react';
import Scene from '../three/Scene';
import Environment from '../three/Environment';
import { useSimulationContext } from '../../providers/SimulationProvider';

function AnamBackgroundCanvas() {
  const { setIsSceneReady } = useSimulationContext();
  return (
    <div className={`absolute top-0 left-0 w-full h-full object-cover`}>
      <Canvas className='w-full h-full'>
        <Suspense>
          <Scene />
          <Environment setIsSceneReady={setIsSceneReady} />
        </Suspense>
      </Canvas>

      {/* Dark overlay */}
      <div className='absolute inset-0 bg-black/20 pointer-events-none' />
    </div>
  );
}
export default AnamBackgroundCanvas;
